<div
  class="business-cohort-group w-full card-bg duration-200 rounded-lg p-6 relative">
  <!-- Header -->
  <div class="mb-6">
    <h2 class="text-lg font-medium text-[#141437] dark:text-white uppercase">Cohort Group Activity</h2>
  </div>

  <!-- Filters Section -->
  <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
    <!-- Timeline Selection (Radio Buttons) -->
    <div class="flex flex-col gap-4">
      <div class="flex items-center gap-4">

        <label class="text-sm font-medium text-slate-700 dark:text-slate-300">Choose Timeline:</label>
        <app-selection [options]="timelineOptions" [variant]="'default'" [size]="'sm'" [mode]="'single'"
          [orientation]="'horizontal'" [name]="'timelineSelector'" (valueChange)="onTimelineChange($event)">
        </app-selection>
      </div>
      <div class="flex items-center gap-4">

        <app-dropdown 
          #yearDropdown
          [options]="yearOptions" 
          [placeholder]="'Select Year'" 
          [selectionMode]="'single'" 
          [size]="'sm'"
          [variant]="'outline'" 
          [searchable]="false" 
          [customWidth]="'120px'" 
          [checkIcon]="'check'"
          [selectionStyle]="'checkbox'"
          [showApplyButton]="true"
          [applyButtonText]="'Apply'" 
          (selectionChange)="onYearChange($event)">
        </app-dropdown>

        <!-- Month Dropdown - Show when timeline is 'month' -->
         @if (selectedTimeline === 'month') {
        <app-dropdown
          #monthDropdown
          [options]="monthOptions" 
          [placeholder]="'Select Month'" 
          [selectionMode]="'single'" 
          [size]="'sm'"
          [variant]="'outline'" 
          [searchable]="false" 
          [customWidth]="'150px'" 
          [selectionStyle]="'checkbox'"
          [showApplyButton]="true"
          [applyButtonText]="'Apply'"
          (selectionChange)="onMonthChange($event)">
        </app-dropdown>
        }

        <!-- Week Dropdown - Show when timeline is 'week' -->
         @if( selectedTimeline === 'week') {
        <app-dropdown 
          #weekDropdown
          [options]="weekOptions" 
          [placeholder]="'Select Week'" 
          [selectionMode]="'single'" 
          [size]="'sm'"
          [variant]="'outline'" 
          [searchable]="false" 
          [customWidth]="'220px'" 
          [selectionStyle]="'checkbox'"
          [showApplyButton]="true"
          [applyButtonText]="'Apply'"
          (selectionChange)="onWeekChange($event)">
        </app-dropdown>
        }
      </div>
    </div>

    <!-- Year Dropdown -->
    <div class="bg-slate-100 dark:bg-slate-700 rounded-lg p-4">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-xs text-slate-600 dark:text-slate-400 uppercase mb-1">Cohort Group</p>
          <div class="flex items-center gap-4">
            <div>
              <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Period:</span>
              <span class="ml-2 text-sm text-slate-800 dark:text-slate-100 font-semibold">{{ cohortStats.period
                }}</span>
            </div>
            <div>
              <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Registration:</span>
              <span class="ml-2 text-sm text-slate-800 dark:text-slate-100 font-semibold">{{ cohortStats.registration
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Cohort Stats Card -->


  <!-- Chart Section -->
  <div class="mb-4">
    <h2 class="text-lg font-medium text-slate-800 dark:text-slate-100 mb-4">Activity of cohort group for next 12
      months</h2>

    <!-- Legend -->
    <div class="flex items-center justify-end gap-6 mb-4">
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-[#8b5cf6] rounded"></div>
        <span class="text-sm text-slate-700 dark:text-slate-300">Active users</span>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-4 h-4 bg-amber-400 rounded-full"></div>
        <span class="text-sm text-slate-700 dark:text-slate-300">Retention Rate</span>
      </div>
    </div>

    <!-- Chart Container -->
    <div class="chart-wrapper w-full h-[400px]">
      <app-bar-line [data1]="chartData" [valueKey]="'active_users'" [otherKey]="'retention_rate'" [valueType]="'%'"
        [colors]="colors" [lineColor]="lineColor" [addGradient]="true" [barTextposition]="'center'" [tooltipData]="toolTipData"
        [labelKey]="selectedTimeline === 'week' ? 'week' : 'month_short'">
      </app-bar-line>
    </div>
  </div>
   @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
</div>